import { useState } from 'react';
import { Typography, FormControlLabel, Checkbox, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { hideModal } from 'src/old/actions/modal/modalActions';
import { useStyles } from './styles';
import GroupHeader from '../GroupHeader';

type BlockCardModalProps = {
  action: () => void;
  lastFour: string;
};

const BlockCardModal = ({ lastFour, action }: BlockCardModalProps) => {
  const [confirmationChecked, setonfirmationChecked] = useState<boolean>(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation(['flexflow']);

  const handleActionButtonClick = () => {
    action();

    hideModal()(dispatch);
  };

  const handleCheckboxCheck = () => {
    setonfirmationChecked(!confirmationChecked);
  };

  return (
    <div className={classes.wrapper}>
      <GroupHeader>{t('block card permanently', { ns: 'flexflow' })}</GroupHeader>
      <div>
        <div className={classes.mainContentWrapper}>
          <Typography variant="subtitle1">
            {t('this action is permanent and cannot be undone', {
              ns: 'flexflow'
            })}
          </Typography>
          <Typography variant="subtitle1" className={classes.marginBottom}>
            {t('blocking the card permanently deactivates the card and it cannot be used again', { ns: 'flexflow' })}
          </Typography>
          <Typography variant="subtitle1" className={classes.marginBottom}>
            {t(
              'when an employee card is blocked, he she will be able to apply for a new card to continue using Flexflow',
              { ns: 'flexflow' }
            )}
          </Typography>
        </div>

        <Typography variant="subtitle2" className={classes.bottomText}>
          <Typography variant="subtitle1" className={classes.question}>
            {t('are you sure you want to block the card permanently', {
              ns: 'flexflow'
            })}
          </Typography>
          <div>
            <FormControlLabel
              control={<Checkbox checked={confirmationChecked} onChange={handleCheckboxCheck} />}
              label={t('I confirm that I want to block the card ending in permanently', { ns: 'flexflow', lastFour })}
            />
          </div>
        </Typography>

        <Button disabled={!confirmationChecked} variant="contained" color="primary" onClick={handleActionButtonClick}>
          {t('block card', {
            ns: 'flexflow'
          })}
        </Button>
      </div>
    </div>
  );
};

export default BlockCardModal;
